import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "checkbox",
    "selectAllButton", 
    "hiddenDayField"
  ]

  initialize() {
    this.updateSelectAllButtonState();
  }

  checkboxChanged(event) {
    const checkbox = event.target;
    const checkboxButton = checkbox.nextElementSibling;
    
    // Update checkbox button styling
    if (checkbox.checked) {
      checkboxButton.classList.add('bg-blue-400', 'text-white', 'border-blue-400');
    } else {
      checkboxButton.classList.remove('bg-blue-400', 'text-white', 'border-blue-400');
    }
    
    this.updateHiddenField();
    this.updateSelectAllButtonState();
  }

  selectAllDays() {
    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = true;
      checkbox.dispatchEvent(new Event('change'));
    });
  }

  updateHiddenField() {
    const checkedBoxes = this.checkboxTargets.filter(checkbox => checkbox.checked);
    const selectedDays = checkedBoxes.map(checkbox => checkbox.value);
    this.hiddenDayFieldTarget.value = selectedDays.join(':');
  }

  updateSelectAllButtonState() {
    const checkedBoxes = this.checkboxTargets.filter(checkbox => checkbox.checked);
    const allSelected = checkedBoxes.length === this.checkboxTargets.length;
    
    if (allSelected) {
      this.selectAllButtonTarget.classList.add('opacity-60', 'pointer-events-none');
    } else {
      this.selectAllButtonTarget.classList.remove('opacity-60', 'pointer-events-none');
    }
  }
}
